import { render, staticRenderFns } from "./UserCardModal.vue?vue&type=template&id=61e8c00e&"
import script from "./UserCardModal.vue?vue&type=script&lang=js&"
export * from "./UserCardModal.vue?vue&type=script&lang=js&"
import style0 from "./UserCardModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports